<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Export
      </v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        outlined
        dense
        v-model="filter.query"
        placeholder="Search..."
        append-icon="fas fa-search"
        clearable
        clear-icon="fas fa-times"
        single-line
        hide-details
        @keyup="itemSearch()"
        @click:clear="itemSearch()"
      ></v-text-field>
    </v-row>

    <v-data-table
      v-model="products"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalCount"
      :footer-props="{ 'items-per-page-options': [5, 10, 50, 100, 250, 500] }"
      show-select      
      :loading="isSearching"
    >

      <template v-slot:item.woo_export_at="{ item }">
        {{ formatDateTime(item.woo_export_at) }}
      </template>

      <template v-slot:footer.prepend>
        <v-btn
          v-if="products.length"
          @click="downloadExport()"
          color="primary"
        >
          Export
        </v-btn>
        <v-btn
          v-if="products.length"
          @click="downloadPrices()"
          color="primary"
          class="ml-3"
        >
          Prices
        </v-btn>
        <span
          v-if="products.length"
          class="ml-5"
        >
          {{ products.length }} selected
        </span>
        <v-btn
          v-if="products.length"
          icon
          x-small
          @click="clearProducts()"
        ><v-icon color="grey">fas fa-times</v-icon></v-btn>
      </template>

    </v-data-table>

  </v-card>
  
</template>

<script>
import { inject, ref } from 'vue'
import { formatDateTime } from '@/utils'

export default {
  components: {
  },
  setup() {
    const api = inject('api')

    const itemCollection = api.collection('products', {
      params: {
        expand: 'category,brand',
      },
      filter: {
        query: 'query:unique_identifier,unique_name',
      },
    })

    const { items, filter, totalCount, options, isSearching } = itemCollection

    const headers = [
      { text: 'Code', value: 'unique_identifier', },
      { text: 'Name', value: 'unique_name' },
      { text: 'Category', value: 'category.name' },
      { text: 'Brand', value: 'brand.name' },
      { text: 'Last export', value: 'woo_export_at' },
    ]

    const { items: brands } = api.collection('brands').all()
    const { items: categories } = api.collection('categories').all()
    const { items: suppliers } = api.collection('suppliers').all()



    const exportModel = api.model('products/export', {
      attributes: {
        product_ids: [],
      },
    })

    function downloadExport() {
      exportModel.setAttribute('product_ids', products.value.map(item => item.id))
      exportModel.create().then(() => {
        const url = exportModel.getAttribute('data_url')
        const link = document.createElement('a')
        link.href = url
        link.download = 'ProductExport.zip'
        link.click()
      })
    }

    const pricesModel = api.model('products/prices', {
      attributes: {
        product_ids: [],
      },
    })
    function downloadPrices() {
      pricesModel.setAttribute('product_ids', products.value.map(item => item.id))
      pricesModel.create().then(() => {
        const url = pricesModel.getAttribute('data_url')
        const link = document.createElement('a')
        link.href = url
        link.download = 'ProductPrices.csv'
        link.click()
      })
    }

    const products = ref([])

    function clearProducts() {
      products.value = []
    }

    const itemSearch = itemCollection.debounceSearch(300)

    return {
      headers,
      items,
      filter,
      itemSearch,
      totalCount,
      options,
      isSearching,
      brands,
      categories,
      suppliers,

      products,
      clearProducts,
      downloadExport,
      downloadPrices,

      formatDateTime,
    }

  },
}
</script>


<style scoped>

:deep(.v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover) {
  cursor: pointer;
}

</style>
